import React, { Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import PropTypes from 'prop-types';
import sad from '../../../images/other-images/sad.png';

const Error404 = ({ t, history }) => (
  <>
    <div className="page-wrapper">
      {/* <!-- error-404 start--> */}
      <div className="error-wrapper">
        <div className="container">
          <img className="img-100" src={sad} alt="" />
          <div className="error-heading">
            <h2 className="headline font-danger">404</h2>
          </div>
          <div className="col-md-8 offset-md-2">
            <p className="sub-content">{t('global.404')}</p>
          </div>
          <div>
            <button
              type="button"
              onClick={() => history.goBack()}
            >
              {t('global.BACK_TO_HOME_PAGE')}
            </button>
          </div>
        </div>
      </div>
      {/* <!-- error-404 end--> */}
    </div>
  </>
);

Error404.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default translate(withRouter(Error404));
